import { render } from "./PositionDetails.vue?vue&type=template&id=e398d6bc"
import script from "./PositionDetails.vue?vue&type=script&lang=js"
export * from "./PositionDetails.vue?vue&type=script&lang=js"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__